import axios from "axios";
import rs_kakao from "@/config/rs_kakao";
import { useAppStore } from "@/stores/app";
import { getCurrentEnv, SUPPORT_ENV } from "@/utils/util";

let config: any = "dev";
const env: any = getCurrentEnv();

if (env === SUPPORT_ENV.prod) {
  config = rs_kakao.prod;
} else if (env === SUPPORT_ENV.qa) {
  config = rs_kakao.qa;
} else {
  config = rs_kakao.dev;
}
export default class Authentication {
  get openID(): string {
    const urlParams = new URLSearchParams(window.location.search);
    const openIdFromUrl = urlParams.get("open_id");

    const openID = localStorage.getItem("openID") ?? openIdFromUrl;
    return openID as string;
  }

  public async lambdaAuthorize(
    accessToken: string,
    idTokenClaims: string,
    type: string
  ): Promise<LoginSuccess> {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
      "x-id-token": idTokenClaims,
    };
    const data = {
      openID: this.openID,
      type,
    };
    const response = await axios({
      url: `${config.base_url}/login`,
      method: "POST",
      headers,
      data,
    });

    const authData = response.data as LoginSuccess;
    this.setAuthentication(authData);
    return authData;
  }

  public async logout(): Promise<void> {
    const data = { type: "logout", openID: this.openID };
    await axios({
      url: `${config.base_url}/login`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${accessToken}`,
        // "x-id-token": idTokenClaims,
      },
      data,
    });

    localStorage.removeItem("authentication");
  }

  public async checkLoggedIn(
    openID: string,
    accessToken: string
  ): Promise<boolean | void> {
    try {
      const app = useAppStore();
      app.setIsloading(true);
      const checkAuthResponse = await axios({
        url: `${config.base_url}/login`,
        method: "POST",
        data: {
          openID,
          type: "check-login",
        },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const { isLoggedIn } = checkAuthResponse.data as CheckAuthResponse;
      app.setIsloading(false);
      return isLoggedIn;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  private setAuthentication(data: LoginSuccess) {
    localStorage.setItem("authentication", JSON.stringify(data));
  }

  public setOpenID(openID: string) {
    localStorage.setItem("openID", openID);
  }
}
